<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>产品管理</el-breadcrumb-item>
      <el-breadcrumb-item>产品类型</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <!-- 添加产品类型按钮 -->
      <el-row>
        <el-col>
          <el-button type="primary" plain icon="el-icon-plus" size="mini" @click="addDialogVisible = true"
            >新增</el-button
          >
          <el-button
            icon="el-icon-download"
            plain
            @click="getpdfyes"
            class="download"
            type="warning"
            size="mini"
          >导出</el-button>
        </el-col>
      </el-row>
      <div>
        <!-- 商品信息表格 -->

        <el-table id="pdfDom" :data="goodslist" class="table01">
          <el-table-column type="index" label="序号" align="center"></el-table-column>
          <el-table-column label="产品类型" prop="TypeName" align="center"></el-table-column>
          <el-table-column
            label="产品类型编号"
            prop="TypeNo"
            width="100%"
            align="center"
          ></el-table-column>
          <el-table-column
            label="创建人"
            prop="CreateUser"
            width="100%"
            align="center"
          ></el-table-column>
          <el-table-column
            label="库存下限"
            prop="Stock_Down"
            width="100%"
            align="center"
          ></el-table-column>
          <el-table-column
            label="库存上限"
            prop="Stock_Up"
            width="100%"
            align="center"
          ></el-table-column>
          <el-table-column
            label="是否使用"
            prop="Is_Use"
            width="90px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="创建时间"
            prop="CreateTimeConvert"
            width="160px"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.CreateTimeConvert }}
            </template>
          </el-table-column>
          <el-table-column
            label="备注"
            prop="Remark"
            width="100px"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                size="mini"
                @click="showEditDialog(scope)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                size="mini"
                @click="removeType(scope)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="getTypeList.page"
        :page-sizes="[5, 10, 15]"
        :page-size="getTypeList.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: right;"
      >
      </el-pagination>
    </el-card>

    <!-- 编辑产品信息的会话框 -->
    <el-dialog
      title="修改产品类型信息"
      :visible.sync="editDialogVisible"
      width="30%"
      @close="editDialogClose"
    >
      <el-form
        :model="editForm"
        :rules="editFormRules"
        ref="editFormRef"
        label-width="100px"
      >
        <el-form-item label="产品类型" prop="TypeName">
          <el-input v-model="editForm.TypeName"></el-input>
        </el-form-item>
        <el-form-item label="产品类型编号" prop="TypeNo">
          <el-input v-model="editForm.TypeNo"></el-input>
        </el-form-item>
        <el-form-item label="创建人" prop="CreateUser">
          <el-input v-model="editForm.CreateUser" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="库存下限" prop="Stock_Down" required>
          <el-input v-model.number="editForm.Stock_Down"></el-input>
        </el-form-item>
        <el-form-item label="库存上限" prop="Stock_Up" required>
          <el-input v-model.number="editForm.Stock_Up"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editProduct">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 添加产品的对话框 -->
    <el-dialog
      title="添加产品类型"
      :visible.sync="addDialogVisible"
      width="25%"
      @close="addDialogClosed"
    >
      <!-- 内容主体区域 -->
      <el-form
        :model="addForm"
        :rules="addFormRules"
        ref="addFormRef"
        label-width="100px"
      >
        <el-form-item label="产品类型" prop="TypeName">
          <el-input
            v-model="addForm.TypeName"
            style="width: 90%"
            size="medium"
          ></el-input>
        </el-form-item>
        <el-form-item label="产品类型编号" prop="TypeNo">
          <el-input
            v-model="addForm.TypeNo"
            style="width: 90%"
            size="medium"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="产品类型" prop="TypeName">
          <el-select v-model="addForm.TypeName" placeholder="请选择产品类型">
            <el-option v-for="item in goodslist" :key="item.ID" :label="item.TypeName" :value="item.TypeName">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="创建人" prop="CreateUser">
          <el-input
            v-model="addForm.CreateUser"
            style="width: 90%"
            size="medium"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="库存下限" prop="Stock_Down" required>
          <el-input
            v-model.number="addForm.Stock_Down"
            style="width: 90%"
            size="medium"
          ></el-input>
        </el-form-item>
        <el-form-item label="库存上限" prop="Stock_Up" required>
          <el-input
            v-model.number="addForm.Stock_Up"
            style="width: 90%"
            size="medium"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="Is_Use">
          <!-- <el-input v-model="addForm.Is_Use" style="width: 90%" size="medium"></el-input> -->
          <el-select v-model="addForm.Is_Use" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input
            v-model="addForm.Remark"
            style="width: 90%"
            size="medium"
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addProduct">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      getTypeList: {
        page: 1,
        limit: 5,
        privateKey: "12a5081e-e354-bada-3952-7a0df30d8849",
        appIdentification: "wms",
      },
      getTypeList1: {
        page: 1,
        limit: 100,
        privateKey: "12a5081e-e354-bada-3952-7a0df30d8849",
        appIdentification: "wms",
      },
      // 产品列表
      goodslist: [],
      // 总数据条数
      total: 0,
      // 控制修改信息对话框的显示与隐藏
      editDialogVisible: false,
      // 控制添加信息对话框的显示与隐藏
      addDialogVisible: false,
      // 编辑用户信息的表单
      editForm: {},
      // 添加用户的表单数据
      addForm: {
        TypeName: "",
        CreateUser: "admin",
        Is_Use: "",
        Remark: "",
        Stock_Down: "",
        Stock_Up: "",
        TypeNo: "",
      },
      //添加表单的验证规则对象
      addFormRules: {
        TypeName: [
          { required: true, message: "请选择产品类型", trigger: "blur" },
        ],
        CreateUser: [
          { required: true, message: "请输入创建人", trigger: "blur" },
          {
            min: 2,
            max: 15,
            message: "用户名的长度在2~15个字符之间",
            trigger: "blur",
          },
        ],
        CreateTime: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        Is_Use: [
          { required: true, message: "请输入是否启用", trigger: "blur" },
          {
            min: 1,
            max: 3,
            message: "用户名的长度在1~3个字符之间",
            trigger: "blur",
          },
        ],
        Stock_Down: [
          {
            type: "number",
            message: "输入必须为大于等于0的整数",
            trigger: "blur",
          },
        ],
        Stock_Up: [
          {
            type: "number",
            message: "输入必须为大于等于0的整数",
            trigger: "blur",
          },
        ],
      },
      // 修改表单的验证规则对象
      editFormRules: {
        TypeName: [{ required: true, message: "请输入类型", trigger: "blur" }],
        CreateUser: [
          { required: true, message: "请输入创建人", trigger: "blur" },
        ],
        Stock_Down: [
          {
            type: "number",
            message: "输入必须为大于等于0的整数",
            trigger: "blur",
          },
        ],
        Stock_Up: [
          {
            type: "number",
            message: "输入必须为大于等于0的整数",
            trigger: "blur",
          },
        ],
      },
      // 是否启用
      options: [
        {
          value: "Y",
          label: "是",
        },
        {
          value: "N",
          label: "否",
        },
      ],
    };
  },
  created() {
    this.getType();
    this.getType1();
  },
  methods: {
    // 调用接口获取产品类型
    async getType() {
      const { data: res } = await this.$http.get("/WMS/queryProductType", {
        params: this.getTypeList,
      });
      console.log(res.data);
      for (var i = 0; i < res.data.length; i++) {
        if (res.data[i].Is_Use == "Y") {
          res.data[i].Is_Use = "是";
        }
        if (res.data[i].Is_Use == "N") {
          res.data[i].Is_Use = "否";
        }
      }
      this.goodslist = res.data;
      // console.log(res.data.length)
    },
    // 调用接口获取产品类型
    async getType1() {
      const { data: res } = await this.$http.get("/WMS/queryProductType", {
        params: this.getTypeList1,
      });
      console.log(res.data);
      this.total = res.data.length;
      // console.log(res.data.length)
    },
    // 调用接口删除产品类型
    async removeType(scope) {
      const confirmResult = await this.$confirm(
        "此操作将永久删除该产品, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);

      if (confirmResult !== "confirm") {
        return this.$message.info("已经取消删除！");
      }

      let params = new URLSearchParams();
      params.append("ID", scope.row.ID);
      params.append("privateKey", this.getTypeList.privateKey);
      params.append("appIdentification", this.getTypeList.appIdentification);
      const { data: res } = await this.$http.post(
        "/WMS/deleteProductType",
        params
      );
      console.log(res);
      if (res == -3) {
        return this.$message.error("已有产品正在使用此类型，无法删除");
      }
      this.$message.success("删除成功！");
      this.getType();
      this.getType1();
    },
    // 展示修改产品的对话框
    async showEditDialog(scope) {
      this.editDialogVisible = true;
      let params = new URLSearchParams();
      params.append("ID", scope.row.ID);
      params.append("privateKey", this.getTypeList.privateKey);
      params.append("appIdentification", this.getTypeList.appIdentification);
      const { data: res } = await this.$http.get("/WMS/queryProductTypeID", {
        params,
      });
      console.log(res.data);
      this.editForm = res.data[0];
    },
    // 监听修改信息对话框的关闭事件
    editDialogClose() {
      this.$refs.editFormRef.resetFields();
    },
    //  监听添加信息对话框的关闭事件
    addDialogClosed() {
      this.$refs.addFormRef.resetFields();
    },
    // 调用接口新增产品类型
    addProduct() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return;
        let params = new URLSearchParams();
        params.append("privateKey", this.getTypeList.privateKey);
        params.append("appIdentification", this.getTypeList.appIdentification);
        params.append("TypeName", this.addForm.TypeName);
        params.append("CreateUser", this.addForm.CreateUser);
        params.append("Is_Use", this.addForm.Is_Use);
        params.append("Remark", this.addForm.Remark);
        params.append("Stock_Down", this.addForm.Stock_Down);
        params.append("Stock_Up", this.addForm.Stock_Up);
        params.append("TypeNo", this.addForm.TypeNo);
        console.log("00" + params);
        // 可以发起添加用户的网络请求
        const { data: res } = await this.$http.post(
          "/WMS/InsertProductType",
          params
        );
        console.log(res);
        console.log(res.data);
        this.$message.success("添加产品类型成功！");
        // 隐藏添加用户的对话框
        this.addDialogVisible = false;
        // 重新获取用户列表数据
        this.getType();
        this.getType1();
      });
    },
    // 调用接口编辑产品类型
    editProduct() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return;
        let params = new URLSearchParams();
        params.append("privateKey", this.getTypeList.privateKey);
        params.append("appIdentification", this.getTypeList.appIdentification);
        params.append("TypeName", this.editForm.TypeName);
        params.append("CreateUser", this.editForm.CreateUser);
        params.append("ID", this.editForm.ID);
        params.append("Is_Use", this.editForm.Is_Use);
        params.append("Remark", this.editForm.Remark);
        params.append("Stock_Down", this.editForm.Stock_Down);
        params.append("Stock_Up", this.editForm.Stock_Up);
        params.append("TypeNo", this.editForm.TypeNo);
        const { data: res } = await this.$http.post(
          "/WMS/updateProductType",
          params
        );
        console.log(res);
        if (res == -2) {
          return this.$message.error("下限大于上限！");
        }
        if (res !== 1) {
          return this.$message.error("更新产品类型信息失败！");
        }

        // 关闭对话框
        this.editDialogVisible = false;
        // 刷新数据列表
        this.getType();
        this.getType1();
        // 提示修改成功
        this.$message.success("更新产品类型信息成功！");
      });
    },
    // 监听 pagesize 改变的事件
    handleSizeChange(newSize) {
      console.log("111" + newSize);
      this.getTypeList.limit = newSize;
      this.getType();
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      console.log(newPage);
      this.getTypeList.page = newPage;
      this.getType();
    },
    getpdfyes() {
      this.getPdf();
    },
  },
};
</script>

<style lang="less" scoped>
</style>

